import { CalendarRejectLeavePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import RejectLeave from 'modules/timeoff/components/RejectLeave'
import { useOnCloseCalendar } from 'modules/timeoff/hooks/useOnCloseCalendar'

const CalendarRejectLeavePage = () => {
  const { leave_id: leaveId } = useStrictParams<'leave_id'>()
  const onClose = useOnCloseCalendar()
  const { onChangeLeave } = useCalendarLeaves()

  const { data } = useQuery(CalendarRejectLeavePageDocument, {
    variables: {
      leaveId: parseInt(leaveId, 10),
    },
  })

  const leaveEmployee = data?.timeoff.leave?.employee

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return (
    <RejectLeave
      leaveId={parseInt(leaveId, 10)}
      onClose={onClose}
      onRejected={onChangeLeave}
      leaveEmployeeId={leaveEmployee.id}
    />
  )
}

export default CalendarRejectLeavePage
